export interface Project {
    id: number;
    title: string;
    description: string;
    tool: string;
    github: string;
    link: string;
}

const ProjectsData: Project[] = [];

export default ProjectsData;
